export default {
    Set: {
        SET_TRACKER_GROUP: 'setAiJobTrackerGroup',
        UPDATE_TRACKER_JOBS: 'updateAiJobTrackerJobs',
        CLEAR_TRACKER_GROUP: 'clearAiJobTrackerGroup',
        CLEAR_TRACKER_JOB: 'clearAiJobTrackerJob',
        SET_AI_IMAGE_SESSION: 'setAiImageSession',
        CLEAR_AI_IMAGE_SESSION: 'clearAiImageSession'
    }
};
